import React, { useState } from 'react';
import { View, StyleSheet } from 'react-native';
import PickerSelect from './PickerSelect';
import FormError from './FormError';
import FormLabel from './FormLabel';

const hourOptions = [...Array(24).keys()].map((hour) => ({
  label: (hour < 10 ? '0' + hour : hour).toString(),
  value: hour,
}));

const minuteOptions = [...Array(60).keys()].map((minute) => ({
  label: (minute < 10 ? '0' + minute : minute).toString(),
  value: minute,
}));

export default function TimeInput({
  label,
  required,
  smallText,
  labelMonth,
  errorMessage,
  onChange = () => null,
  initialValue = { hours: '', minutes: '' },
}) {
  const [time, setTime] = useState(initialValue);

  const changeTime = (timeField) => (value) => {
    setTime({ ...time, [timeField]: value });
    onChange({ ...time, [timeField]: value });
  };

  return (
    <View style={styles.container}>
      {!!label && <FormLabel label={label} required={required} smallText={smallText} />}
      <View style={styles.dateFormWrapper}>
        <View style={styles.hoursWrapper}>
          <PickerSelect
            items={hourOptions}
            value={time.hours}
            onValueChange={changeTime('hours')}
            placeholder={{ label: labelMonth ? labelMonth : 'Time' }}
          />
        </View>
        <View style={styles.monthPickerWrapper}>
          <PickerSelect
            items={minuteOptions}
            value={time.minutes}
            onValueChange={changeTime('minutes')}
            placeholder={{ label: labelMonth ? labelMonth : 'Time' }}
          />
        </View>
      </View>
      {!!errorMessage && <FormError errorMessage={errorMessage} />}
    </View>
  );
}
const styles = StyleSheet.create({
  container: {
    display: 'flex',
  },
  dateFormWrapper: {
    display: 'flex',
    flexDirection: 'row',
  },
  monthPickerWrapper: {
    flex: 1,
    display: 'flex',
    flexDirection: 'row',
  },
  hoursWrapper: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    marginRight: 18,
  },
});
